import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { firstValueFrom } from 'rxjs'

import { TargetApiRoutes } from '../enums/target-api-routes.enum'
import { Environment } from '../interfaces/environment.interface'
import { Country } from '../interfaces/resources/country.interface'
import { EnvironmentService } from './environment.service'
import { CountryGroup } from '../interfaces/resources/country-group.inerface'

@Injectable({
  providedIn: 'root'
})
export class CountryService {
  environment: Environment

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) {
    this.environmentService.loadEnvironment().subscribe((env) => {
      this.environment = env
    })
  }

  async list(): Promise<Country[]> {
    return firstValueFrom(
      this.http.get(
        `${this.environment.apiBaseUrl}${TargetApiRoutes.Countries}`
      )
    ).then((countriesRes: Object) => {
      return countriesRes as Country[]
    })
  }

  async show(id: string): Promise<Country> {
    return firstValueFrom(
      this.http.get(
        `${this.environment.apiBaseUrl}${TargetApiRoutes.Country}&id=${id}`
      )
    ).then((countryRes: Object) => {
      return countryRes as Country
    })
  }

  async showByFamily(id: string, dataset?: string): Promise<Country> {
    const datasetParam = dataset ? `&dataset=${dataset}` : ''

    return firstValueFrom(
      this.http.get(
        `${this.environment.apiBaseUrl}${TargetApiRoutes.Country}&id=${id}${datasetParam}`
      )
    ).then((countryRes: Object) => {
      return countryRes as Country
    })
  }

  private readonly countryGroupOrder = [
    {
      name: 'Expenditure-based only',
      label: 'Countries offering expenditure-based tax incentives only in 2025'
    },
    {
      name: 'Income-based only',
      label: 'Countries offering income-based tax incentives only in 2025'
    },
    {
      name: 'Expenditure and income-based',
      label: 'Countries offering expenditure- and income-based tax incentives in 2025'
    },
    {
      name: 'No tax incentives',
      label: 'Countries without tax incentives for R&D and innovation in 2025'
    }
  ];

  groupCountries(countries: Country[]): CountryGroup[] {
    return this.countryGroupOrder
      .map(group => ({
        name: group.name,
        label: group.label,
        countries: countries.filter(country => country.group === group.name)
      }))
      .filter(group => group.countries.length > 0);
  }
}
